export const validateURL = (url: string): boolean => {
    try {
        const parsed = new URL(url)
        return ['https:', 'http:'].includes(parsed.protocol)
    } catch (error) {
        return false;
    }
}